import React from 'react'
import ImageWithFallback from './widgets/ImageWithFallback'

export default function AttachmentPreviewBox({ name, href }) {
  return (
    <div className="attachment-preview-box">
      <div className="attachment-wrapper">
        <div>
          <ImageWithFallback className="attachment-preview" src={href} fallbackSrc="/images/file-thumbnail.png" />
          <div>
            <a target="_blank" rel="noopener noreferrer" href={href}>
              {name}
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
